import { render, staticRenderFns } from "./CircolariInviate.vue?vue&type=template&id=4c031703&scoped=true&"
import script from "./CircolariInviate.vue?vue&type=script&lang=js&"
export * from "./CircolariInviate.vue?vue&type=script&lang=js&"
import style0 from "./CircolariInviate.vue?vue&type=style&index=0&id=4c031703&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c031703",
  null
  
)

export default component.exports